var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header", [
        _c("div", { staticClass: "header-row" }, [
          _c("nav", { staticClass: "navbar navbar-expand" }, [
            _c("ul", { staticClass: "navbar-nav align-items-center" }, [
              _vm._m(0),
              _vm._v(" "),
              !_vm.utils.isPwResetUser()
                ? _c(
                    "li",
                    {
                      staticClass: "nav-item",
                      on: {
                        click: function($event) {
                          return _vm.clearPreInputVoucher()
                        }
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          class: {
                            active:
                              _vm.listCashCarry.includes(_vm.currentPage) &&
                              !_vm.$route.query.groupType
                          },
                          attrs: { to: { path: "/tour/input" }, refresh: "" }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("header.carry_cash_details")) +
                              "\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.utils.isPwResetUser()
                ? _c("li", { staticClass: "nav-item dropdown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        class: {
                          active:
                            _vm.$route.query.groupType &&
                            _vm.$route.query.groupType !=
                              _vm.constants.GroupVoucherType.non_travel.id
                        },
                        attrs: { "data-toggle": "dropdown" }
                      },
                      [_vm._v(_vm._s(_vm.$t("header.certi_regis")))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu sub-menu" }, [
                      _c("ul", { staticClass: "lst-btns" }, [
                        !_vm.utils.isCooperator()
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-link-menu",
                                  attrs: {
                                    href:
                                      "/voucher/list?groupType=" +
                                      _vm.constants.GroupVoucherType
                                        .invoice_bill.id
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t("header.group.invoice_bill")
                                      ) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link-menu",
                              attrs: {
                                href:
                                  "/voucher/list?groupType=" +
                                  _vm.constants.GroupVoucherType
                                    .local_expense_voucher.id
                              },
                              on: {
                                click: function($event) {
                                  return _vm.clearPreInputVoucher()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("header.group.local_expense_voucher")
                                )
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.utils.isAdminAndSystemAdmin()
                ? _c("li", { staticClass: "nav-item dropdown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        class: {
                          active:
                            _vm.$route.query.groupType ==
                            _vm.constants.GroupVoucherType.non_travel.id
                        },
                        attrs: { "data-toggle": "dropdown" }
                      },
                      [_vm._v(_vm._s(_vm.$t("header.non_travel_account")))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu sub-menu" }, [
                      _c("ul", { staticClass: "lst-btns" }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link-menu",
                              attrs: {
                                href:
                                  "/voucher/list?groupType=" +
                                  _vm.constants.GroupVoucherType.non_travel.id +
                                  "&voucherType=" +
                                  _vm.constants.VoucherType.non_travel_contract
                                    .id
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("header.non_travel_group.contract")
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link-menu",
                              attrs: {
                                href:
                                  "/voucher/list?groupType=" +
                                  _vm.constants.GroupVoucherType.non_travel.id +
                                  "&voucherType=" +
                                  _vm.constants.VoucherType
                                    .non_travel_invoice_bill.id
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("header.non_travel_group.invoice_bill")
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link-menu",
                              attrs: {
                                href:
                                  "/voucher/list?groupType=" +
                                  _vm.constants.GroupVoucherType.non_travel.id +
                                  "&voucherType=" +
                                  _vm.constants.VoucherType.non_travel_other.id
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("header.non_travel_group.other"))
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.utils.isAdminAndSystemAdmin() ||
              _vm.utils.isPwResetUser() ||
              _vm.utils.isReadOnly()
                ? _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          class: [
                            _vm.listAdminPage.includes(_vm.currentPage)
                              ? _vm.activeClass
                              : ""
                          ],
                          attrs: { to: { path: "/admin/users" }, exact: "" }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("header.menu_admin")) +
                              "\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user
                ? _c("li", { staticClass: "user-info-box ml-auto" }, [
                    _c("div", { staticClass: "user-info" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/sprite/icon-user-white@2x.png"),
                          height: "20"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-name user-ellipsis" }, [
                        _c("span", [_vm._v(_vm._s(_vm.user.full_name))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-info" }, [
                      _c("div", { staticClass: "user-ellipsis" }, [
                        _c("span", [_vm._v(_vm._s(_vm.user.company_name))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-info" }, [
                      _c("div", { staticClass: "user-ellipsis" }, [
                        _c("span", [_vm._v(_vm._s(_vm.user.branch))])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("header.logout")))]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("select-contract-modal")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c("a", { staticClass: "nav-link ex-nav-logo", attrs: { href: "#" } }, [
        _c("img", {
          staticClass: "nav-link-logo",
          attrs: {
            src: require("@/assets/img/logo_jtb_wht@2x.png"),
            alt: "Logo"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a1f17be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1f17be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/pc/Header.vue
// module id = null
// module chunks = 